<template>
    <div class="footer-container">
    <!--logo-->
        <div class="bottom-logo"><img style="height: 58px;width: auto;" src="@/assets/icon/logo.png" alt=""></div>
        <ul class="code-list">
            <li class="code-item">
                <div class="code-img"><img src="@/assets/icon/join-code.png" alt=""></div>
                <div class="code-text">扫一扫关注加盟公众号</div>
            </li>
            <li class="code-item">
                <div class="code-img"><img src="@/assets/icon/douyin-code.png" alt=""></div>
                <div class="code-text">扫一扫关注抖音</div>
            </li>
            <li class="code-item">
                <div class="code-img"><img src="@/assets/icon/weibo-code.jpg" alt=""></div>
                <div class="code-text">扫一扫关注微博</div>
            </li>
            <li class="code-item">
                <div class="code-img"><img src="@/assets/icon/jianli-code.png" alt=""></div>
                <div class="code-text">扫一扫投递简历</div>
            </li>
            <li class="code-item">
                <div class="code-img"><img src="@/assets/icon/weixin-code.png" alt=""></div>
                <div class="code-text">扫一扫关注公众号</div>
            </li>
            <li class="code-item">
                <div class="code-img"><img src="@/assets/icon/xhs-code.jpg" alt=""></div>
                <div class="code-text">扫一扫关注小红书</div>
            </li>
        </ul>
        <div class="footer-infs">
            <div class="footer-item b-right">
                <div class="footer-content-left">
                    <div class="footer-content-title">联系我们</div>
                    <div class="footer-content-entitle">CONSULTATIVE</div>
                </div>
                <ul class="footer-list">
                    <li class="footer-line">
                        <span class="footer-line-bold">人才招聘</span>
                        <span class="footer-line-light">Email: {{ cardData.hrEmail }}</span>
                    </li>
                    <li class="footer-line">
                        <span class="footer-line-bold">媒体采访</span>
                        <span class="footer-line-light">Email: {{ cardData.mrEmail }}</span>
                    </li>
                    <li class="footer-line">
                        <span class="footer-line-bold">媒体合作</span>
                        <span class="footer-line-light">Email: {{ cardData.prEmail }}</span>
                    </li>
                </ul>
            </div>
            <div class="footer-item">
                <div class="footer-content-left">
                    <div class="footer-content-title">公司地址</div>
                    <div class="footer-content-entitle">ADDRESS</div>
                </div>
                <ul class="footer-list">
                    <li class="footer-line">
                        <span class="footer-line-bold">总部公司地址</span>
                        <span class="footer-line-light">湖南省长沙市芙蓉区长沙大道运达中央广场A座35楼</span>
                    </li>
                    <li class="footer-line">
                        <span class="footer-line-bold">合肥公司地址</span>
                        <span class="footer-line-light">安徽省合肥市包河区绿地中心D座2910</span>
                    </li>
                    <li class="footer-line">
                        <span class="footer-line-bold">广州公司地址</span>
                        <span class="footer-line-light">广州番禺区启迪数字大厦B座23楼</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="copy-right">Copyright 2022 © 宜春市赵一鸣商贸有限公司版权所有</div>
        <div class="copy-right">ALL Rights Reserved 赣ICP备2022002236号-3</div>
        <div class="copy-right">赣公网安备36090202000291号 <span style="cursor: pointer;" @click="goDialog('https://server.zymls.com/privacyPolicy.html')">隐私协议</span></div>
        <div class="copy-right">加盟有风险，投资需谨慎！</div>
        <!--悬浮按钮，在线客服-->
        <div class="float-icon" @click="showPrivacyDialog = true"><img src="@/assets/icon/icon-kf.png" alt=""></div>
        <div v-show="isShowDialog" class="float-dialog">
            <span class="float-dialog-close" @click="updateDialog(false)">关闭</span>
            <iframe class="kf-iframe" src="https://kfgd.hnlshm.com/chat.react/ym_chat.html?queue=415&from=pc&channel=0" frameborder="0"></iframe>
        </div>

    <div v-if="showPrivacyDialog" class="privacy-dialog">
        <div class="privacy-dialog-content">
            <iframe class="privacy-iframe" src="https://server.zymls.com/privacyPolicy.html" frameborder="0"></iframe>
            <div class="privacy-options">
                <label class="privacy-checkbox">
                    <input type="checkbox" v-model="isPrivacyChecked">
                    
                    <span>我已阅读并同意隐私政策</span>
                </label>
                <div>
                    <button  @click="showPrivacyDialog = false">取消</button>
                    <button :disabled="!isPrivacyChecked" @click="showPrivacyDialog = false;updateDialog(true)">联系客服</button>
                </div>
                
            </div>
        </div>
    </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            cardData:{
                hrEmail:'https://hnlshm3.zhiye.com',
                mrEmail:'mmhm-pr@hnlshm.com',
                prEmail:'lihongxiang@hnlshm.com',
                joinLink:null,
            },
            showPrivacyDialog: false,
            isShowDialog:false,
            isPrivacyChecked: false
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        goDialog(url){

            url ? window.open(url,'_blank') : '';
        },
        getData(){
            const url = this.$WEBSITE_URL_OBJECT.osconfig;
            this.$axios.get(url).then(res=>{
                const {data} = res.data;
                if(res.data.code === 0){
                    // this.cardData = {
                    //     hrEmail:data.hrEmail,
                    //     mrEmail:data.mrEmail,
                    //     prEmail:data.prEmail,
                    //     joinLink:data.joinLink
                    // }
                }
            })
        },
        updateDialog(flag){
            // this.isShowDialog = flag;
            // const timestamp = new Date().getTime();
            // let timeStr = timestamp.toString();
            // timeStr = timeStr.substring(0,timeStr.length - 1);
            // const data = {
            //     "request_time": timeStr,
            //         "data_industry": "ocpc_ps_convert",
            //         "data_detail": {
            //             "qhclickid": "SATss81125282002",
            //             "trans_id": "6614b3ac48efe47365",
            //             "event": "SUBMIT",
            //             "event_time": timeStr
            //         }
            // }
            // const requestUrl = 'https://convert.dop.360.cn/uploadWebConvert';
            // this.$axios.post(requestUrl,data)
            const url = 'https://kfgd.hnlshm.com/chat.react/ym_chat.html?queue=415&from=pc&channel=0';
            window.open(url,'_blank');
        }
    }
}
</script>
<style scoped>
@media screen and (max-width: 1700px){
    .float-icon img{
        width: 100px!important;
    }
}
.footer-container{
    padding-top: 50px;
    padding-bottom: 80px;
    background-color: #fff;
    overflow: hidden;
    font-family: Source Han Sans;
}
.code-list{
    display: flex;
    justify-content: center;
}
.code-item{
    padding: 10px 20px;
}
.code-img{
    width: 182px;
    height: 182px;
}
.code-img img{
    width: 100%;
    height: 100%;
}
.code-text{
    padding: 16px 0;
    font-size: 18px;
    /* font-family: Source Han Sans CN-Regular, Source Han Sans CN; */
    font-weight: 400;
    color: #000000;
    line-height: 27px;
    text-align: center;
}
.footer-infs{
    display: flex;
    justify-content: center;
}
.footer-item{
    width: 700px;
    margin: 40px 0;
    padding: 0 50px;
    display: flex;
    justify-content: center;
}
.footer-content-title{
    width: 136px;
    font-size: 32px;
    /* font-family: Source Han Sans CN-Bold, Source Han Sans CN; */
    font-weight: bold;
    color: #E60012;
    line-height: 48px;
}
.footer-content-entitle{
    font-size: 18px;
    /* font-family: Source Han Sans CN-Regular, Source Han Sans CN; */
    font-weight: 400;
    color: #000000;
    line-height: 27px;
}
.footer-list{
    padding-left: 24px;
}
.footer-line{
    padding: 8px 0;
}
.footer-line-bold{
    padding-right: 10px;
    font-size: 18px;
    /* font-family: Source Han Sans CN-Bold, Source Han Sans CN; */
    font-weight: bold;
    color: #000000;
    line-height: 27px;
}
.footer-line-light{
    font-size: 18px;
    /* font-family: Source Han Sans CN-Light, Source Han Sans CN; */
    font-weight: 300;
    color: #000000;
    line-height: 27px;
}
.b-right{
    border-right: 1px solid rgba(156,156,156,.3);
}
.copy-right{
    padding: 6px 0;
    font-size: 14px;
    /* font-family: Source Han Sans CN-Light, Source Han Sans CN; */
    font-weight: 300;
    color: #000000;
    line-height: 21px;
    text-align: center;
}
.bottom-logo{
    text-align: center;
}
.float-icon{
    position: fixed;
    bottom: 150px;
    right: 60px;
    z-index: 9;
}
.float-icon img{
    display: block;
    width: 120px;
    height: auto;
}
.float-icon:hover{
    cursor: pointer;
    transform: scale(1.05);
}
.float-dialog{
    position: fixed;
    width: 900px;
    height: 700px;
    top: 50%;
    left: 50%;
    margin: -350px -450px;
    z-index: 10;
    background-color: #e5010e;
    border-radius: 16px;
    overflow: hidden;
}
.float-dialog-top{
    text-align: right;
}
.float-dialog-close{
    position: absolute;
    top: 8px;
    right: 40px;
    padding: 10px;
    font-size: 14px;
    color: #fff;
}
.float-dialog-close:hover{
    cursor: pointer;
}
.kf-iframe{
    width: 100%;
    height: 700px;
}
.privacy-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 11;
}
.privacy-dialog-content {
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    width: 80%;
    max-width: 800px;
    height: 80%;
    max-height: 600px;
    display: flex;
    flex-direction: column;
    padding: 20px; 
}
.privacy-iframe {
    flex-grow: 1;
    border: none;
}
.privacy-options {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.privacy-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    
}
.privacy-checkbox input {
    margin-right: 8px;
}
.privacy-checkbox .checkmark {
    width: 16px;
    height: 16px;
    border: 1px solid #000;
    display: inline-block;
}
.privacy-options button {
    padding: 8px 16px;
    background-color: #e60012;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
.privacy-options button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue